import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBucket: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconBucket"><Path d="M2.75 3C2.33579 3 2 3.25184 2 3.5625V6.9375C2 7.24816 2.33579 7.5 2.75 7.5H21.25C21.6642 7.5 22 7.24816 22 6.9375V3.5625C22 3.25184 21.6642 3 21.25 3H2.75Z" fill="currentColor"/><Path d="M3.58503 9L4.78644 18.5918C4.95878 19.9677 6.1285 21 7.51512 21H16.4849C17.8715 21 19.0412 19.9677 19.2136 18.5918L20.415 9H3.58503Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBucket;
